/**
 * Палитра темы — единственное место, где живут цвета сайта.
 *
 * Файл читают ДВОЕ, поэтому он написан на CommonJS:
 *   1) tailwind.config.js — Node на сборке, require('./src/lib/themePalette');
 *   2) компоненты — webpack, import { PALETTE } from '../lib/themePalette'.
 *
 * Выбор набора — переменная сборки REACT_APP_THEME (sky | violet), значение
 * по умолчанию sky = сегодняшний астрофил.рф. Ни одно значение набора sky не
 * отличается от того, что стоит в коде сейчас, поэтому без выставленной
 * переменной сайт не меняется ни в чём. Второй экземпляр (astrofeel.ru)
 * задаётся одной переменной в панели Timeweb: REACT_APP_THEME=violet.
 *
 * Токены названы по РОЛИ, а не по цвету: на голубой сборке имя вроде gold-500
 * означало бы фиолетовый и путало бы через месяц.
 *   theme-50…950     — основная палитра сайта. Тем же объектом заведено
 *                      семейство sky, чтобы 608 существующих классов sky-*
 *                      в компонентах остались нетронутыми и переключались
 *                      вместе с темой.
 *   surface-*        — фон страницы и рамки каркаса.
 *   accent-cta-*     — фирменная линия призывов к действию (промо-полоса,
 *                      кнопки «Рассчитать», бейджи, зонирующие фоны).
 *                      Ступени 75 и 150 — не прихоть: на рф рядом живут
 *                      #DBF0FF и #DBEFFD, #C7E9FC и #C8E4F9; свести их
 *                      значило бы поменять прод, пусть и незаметно глазу.
 *   accent-horar-*   — акцент экранов хорара (выбор варианта, фокус полей).
 *   accent-pro-*     — акцент платного: карточка ПРО, письма, лимит-модалки.
 *   accent-doc       — акцент документа PDF (шапка, заголовки, подвал).
 *   accent-alt       — запасной второй акцент. Сейчас не используется нигде.
 *   tier-*           — витрина тарифов. На violet лесенка «чем дороже, тем
 *                      заметнее»: FREE нейтральный, ЛАЙТ сиреневый,
 *                      ПРО золото 500/600, МАСТЕР золото 700/800.
 *
 * НЕ ТЕМА и здесь не лежит: цвета аспектов (Соединение голубое, гармоничные
 * зелёные, напряжённые красные), палитра вердиктов хорара, графика колеса и
 * глифы планет, статусные зелёный/красный/янтарный, нейтральный slate,
 * фирменные цвета соцсетей. Они одинаковы на обоих сайтах.
 */

var THEMES = {
  sky: {
    theme: {
      50: '#f0f9ff', 100: '#e0f2fe', 200: '#bae6fd', 300: '#7dd3fc',
      400: '#38bdf8', 500: '#0ea5e9', 600: '#0284c7', 700: '#0369a1',
      800: '#075985', 900: '#0c4a6e', 950: '#082f49',
    },
    surface: { base: '#dbeafe', soft: '#f8fafc', border: '#e2e8f0' },
    'accent-cta': {
      50: '#F4FAFF', 75: '#DBF0FF', 100: '#DBEFFD', 150: '#C7E9FC',
      200: '#C8E4F9', 300: '#7CCDF5', 500: '#008FD3', 600: '#007FC0',
      700: '#006BA6', 800: '#005A8C',
    },
    'accent-horar': { 50: '#e0f7fa', 500: '#00b4d8', 600: '#0096c7', 700: '#0077b6' },
    'accent-pro': {
      50: '#f5f3ff', 100: '#ede9fe', 200: '#ddd6fe', 300: '#c4b5fd',
      400: '#a78bfa', 500: '#8b5cf6', 600: '#7c3aed', 700: '#6d28d9',
      800: '#5b21b6', 900: '#4c1d95',
      // Кнопка «Открыть ПРО» — инлайновый градиент, живёт вне шкалы.
      'grad-from': '#7B61FF', 'grad-to': '#9F7AEA',
    },
    'accent-doc': '#7c3aed',
    'accent-alt': '#D95B95',
    tier: {
      'free-bg': '#F4FAFF', 'free-border': '#7CCDF5', 'free-badge': '#DBEFFD',
      'free-badge-text': '#007FC0', 'free-btn': '#008FD3', 'free-btn-hover': '#007FC0',
      'light-bg': '#F3EEFF', 'light-border': '#C9B2F2', 'light-badge': '#E9E0FA',
      'light-badge-text': '#7B58A6', 'light-btn': '#8F6DB2', 'light-btn-hover': '#7B58A6',
      'pro-bg': '#FFF0F6', 'pro-border': '#F6B5D3', 'pro-badge': '#FCE1EE',
      'pro-badge-text': '#C2185B', 'pro-btn': '#E84393', 'pro-btn-hover': '#D6317F',
      'master-bg': '#FFF0F6', 'master-border': '#F49BC1', 'master-badge': '#FBD5E6',
      'master-badge-text': '#AD1457', 'master-btn': '#D6317F', 'master-btn-hover': '#C2185B',
    },
  },

  violet: {
    // Шкала снята с живого astrofeel.ru (ступени 50…900), 950 достроена.
    theme: {
      50: '#F8F5FC', 100: '#EAE1F2', 200: '#D8CEE6', 300: '#C4B0DC',
      400: '#A88FC5', 500: '#8B6BAE', 600: '#7A5A9E', 700: '#664B88',
      800: '#503871', 900: '#3A2759', 950: '#26193A',
    },
    surface: { base: '#FDFBFD', soft: '#F7F4FA', border: '#E8E3EE' },
    'accent-cta': {
      50: '#F9F6FD', 75: '#F1EAF8', 100: '#EDE4F5', 150: '#E0D3EE',
      200: '#DED0EC', 300: '#BFA6DB', 500: '#7E5CA6', 600: '#6E4E93',
      700: '#5C407C', 800: '#4A3364',
    },
    'accent-horar': { 50: '#F3EEF9', 500: '#9B7BC0', 600: '#85669F', 700: '#6E5285' },
    // Тёплое золото. Текст берём с 700 (контраст на белом 6.3:1),
    // кнопку — с 500/600: золото 500 на белом для текста не дотягивает.
    'accent-pro': {
      50: '#FDF8EC', 100: '#F8ECCB', 200: '#EFD9A0', 300: '#E3C06B',
      400: '#D2A93C', 500: '#B8860B', 600: '#9C7009', 700: '#7D5A0B',
      800: '#63480C', 900: '#4A360B',
      'grad-from': '#A87515', 'grad-to': '#D4A93F',
    },
    'accent-doc': '#7A5A9E',
    'accent-alt': '#D95B95',
    tier: {
      'free-bg': '#F7F6F8', 'free-border': '#DCD8E0', 'free-badge': '#EDEAF0',
      'free-badge-text': '#6E6878', 'free-btn': '#8B8593', 'free-btn-hover': '#767083',
      'light-bg': '#F8F5FC', 'light-border': '#C4B0DC', 'light-badge': '#EAE1F2',
      'light-badge-text': '#664B88', 'light-btn': '#8B6BAE', 'light-btn-hover': '#7A5A9E',
      'pro-bg': '#FDF8EC', 'pro-border': '#E3C06B', 'pro-badge': '#F8ECCB',
      'pro-badge-text': '#7D5A0B', 'pro-btn': '#B8860B', 'pro-btn-hover': '#9C7009',
      'master-bg': '#FBF3E2', 'master-border': '#D2A93C', 'master-badge': '#EFD9A0',
      'master-badge-text': '#63480C', 'master-btn': '#7D5A0B', 'master-btn-hover': '#63480C',
    },
  },
};

var raw = (process.env.REACT_APP_THEME || '').trim().toLowerCase();
var THEME = Object.prototype.hasOwnProperty.call(THEMES, raw) ? raw : 'sky';

var PALETTE = THEMES[THEME];

// Градиент кнопки «Открыть ПРО» — одной строкой, чтобы шесть экранов не
// собирали его каждый по-своему.
var PRO_GRADIENT = 'linear-gradient(135deg, ' + PALETTE['accent-pro']['grad-from'] +
  ', ' + PALETTE['accent-pro']['grad-to'] + ')';

module.exports = { THEME: THEME, PALETTE: PALETTE, PRO_GRADIENT: PRO_GRADIENT, THEMES: THEMES };
